import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './MovuRobotics.frontend.types'

@Injectable({ providedIn: 'root' })
export class MovuRobotics_send_http_requestService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { payload: string, messageTransactionId: string, warehouseId: number, executionContext: $frontendTypes.MovuRobotics.OperationTypes }): Promise<{ responseResult?: $frontendTypes.MovuRobotics.Output, outputDetails?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.payload)) {
      $missingRequiredInParams.push('\'payload\'');
    }
    if (isNil($inParams.messageTransactionId)) {
      $missingRequiredInParams.push('\'messageTransactionId\'');
    }
    if (isNil($inParams.warehouseId)) {
      $missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil($inParams.executionContext)) {
      $missingRequiredInParams.push('\'executionContext\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

